import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { BeautyIngredientDetail } from '@domains/pdp-common';

interface Props {
  item: BeautyIngredientDetail['ingredient_list'][number];
  colors: {
    primary: string;
    warning: string;
  };
}

export const IngredientListItem: FC<React.PropsWithChildren<Props>> = ({ item, colors }) => {
  const primaryDiscription = item.primary_description_list.map((item) => item.description).join(', ');
  const warningDiscription = item.warning_description_list.map((item) => item.description).join(', ');
  const purposeText = item.combination_purpose_list.join(', ');

  return (
    <Root>
      {(primaryDiscription || warningDiscription) && (
        <Descirptions>
          {primaryDiscription && (
            <DescriptionText className={Typography.BODY_13_MEDIUM} color={colors.primary}>
              {primaryDiscription}
            </DescriptionText>
          )}
          {primaryDiscription && warningDiscription && <Bar />}
          {warningDiscription && (
            <DescriptionText className={Typography.BODY_13_MEDIUM} color={colors.warning}>
              {warningDiscription}
            </DescriptionText>
          )}
        </Descirptions>
      )}
      <IngredientText className={Typography.BODY_15_MEDIUM}>{item.name}</IngredientText>
      <CombinationPurposeText className={Typography.BODY_13_REGULAR}>
        {purposeText !== '' && `배합목적: ${purposeText}`}
      </CombinationPurposeText>
    </Root>
  );
};

const Root = styled.li`
  padding: 20px 0;
  border-bottom: 1px solid ${vars.v3Color.gray100};
`;

const Descirptions = styled.div`
  margin-bottom: 6px;
`;

const DescriptionText = styled.span<{ color: string }>`
  color: ${({ color }) => color};
`;

const Bar = styled.span`
  display: inline-block;
  width: 1px;
  height: 10px;
  background: ${vars.v3Color.gray150};
  margin: 0 6px;
`;

const IngredientText = styled.p`
  margin-bottom: 6px;
  line-height: 140%;
`;

const CombinationPurposeText = styled.p`
  color: ${vars.v3Color.gray500};
  line-height: 140%;
`;
